var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#1FAB89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 9H8.99935C8.64573 9 8.30659 9.14048 8.05654 9.39052C7.80649 9.64057 7.66602 9.97971 7.66602 10.3333V12.3333H8.99935V10.3333H20.9993V19.6667H16.3327V21H20.9993C21.353 21 21.6921 20.8595 21.9422 20.6095C22.1922 20.3594 22.3327 20.0203 22.3327 19.6667V10.3333C22.3327 9.97971 22.1922 9.64057 21.9422 9.39052C21.6921 9.14048 21.353 9 20.9993 9ZM7.66602 19V21H9.66602C9.66602 20.4696 9.4553 19.9609 9.08023 19.5858C8.70516 19.2107 8.19645 19 7.66602 19ZM7.66602 16.3333V17.6667C8.10376 17.6667 8.53721 17.7529 8.94163 17.9204C9.34605 18.0879 9.71351 18.3334 10.023 18.643C10.3326 18.9525 10.5781 19.32 10.7456 19.7244C10.9131 20.1288 10.9993 20.5623 10.9993 21H12.3327C12.3327 19.7623 11.841 18.5753 10.9658 17.7002C10.0907 16.825 8.90369 16.3333 7.66602 16.3333ZM7.66602 13.6667V15C8.45395 15 9.23416 15.1552 9.96212 15.4567C10.6901 15.7583 11.3515 16.2002 11.9087 16.7574C12.4658 17.3145 12.9078 17.9759 13.2093 18.7039C13.5108 19.4319 13.666 20.2121 13.666 21H14.9993C14.9993 16.9467 11.7127 13.6667 7.66602 13.6667ZM14.3327 14.3933V15.7267L16.666 17L18.9993 15.7267V14.3933L16.666 15.6667L14.3327 14.3933ZM16.666 11L12.9993 13L16.666 15L20.3327 13L16.666 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerBuilding);
export default __webpack_public_path__ + "static/media/career-building.8d10fe306be3aafd0eb1888f953ae8ea.svg";
export { ForwardRef as ReactComponent };